import { EntityOwnerPersonWorkTimeType } from './EntityOwnerPersonWorkTimeType';

export const EntityOwnerPersonWorkTimeTypeOptions = [
    {
        id: EntityOwnerPersonWorkTimeType.FullTime,
        text: 'Full',
    },
    {
        id: EntityOwnerPersonWorkTimeType.PartTime,
        text: 'Part',
    },
];
